// src/themes/modern/menu/components/MenuItemGrid.tsx
import { motion } from 'framer-motion';
import React from 'react';
import type { Branch, MenuItem } from '~/types/new_types';
import MenuItemGridCard from './MenuItemGridCard';

interface MenuItemGridProps {
	items: MenuItem[];
	theme: Branch['theme'];
	setSelectedItem?: React.Dispatch<React.SetStateAction<MenuItem | null>>;
}

const MenuItemGrid: React.FC<MenuItemGridProps> = ({ items, theme, setSelectedItem }) => {
	// Animation variants
	const containerVariants = {
		hidden: { opacity: 0 },
		visible: {
			opacity: 1,
			transition: {
				staggerChildren: 0.1
			}
		}
	};

	const itemVariants = {
		hidden: { opacity: 0, y: 20 },
		visible: {
			opacity: 1,
			y: 0,
			transition: {
				type: "spring" as const,
				stiffness: 100,
				damping: 15
			}
		}
	};

	return (
		<motion.div
			className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-6"
			variants={containerVariants}
			initial="hidden"
			animate="visible"
		>
			{items.map((item, index) => (
				<motion.div
					key={item.id}
					variants={itemVariants}
					custom={index}
				>
					<MenuItemGridCard
						item={item}
						onClick={() => setSelectedItem?.(item)}
					/>
				</motion.div>
			))}
		</motion.div>
	);
};

export default MenuItemGrid;